import { ApiManager } from "../api/ApiManager";
import EHRApis from "../api/EHRApis";
import { IFetchScheduledInterventionsProgressRequest, IFetchScheduledInterventionsProgresssResponse, IFetchScheduledInterventionsRequest, IFetchScheduledInterventionsResponse } from "../models/IFetchScheduledInterventions";
import { ISugarJournalRequest } from "../models/ISugarJournalRequest";
import { ISugarJournalResponse } from "../models/ISugarJournalResponse";

export class InterventionsActions {
    static getIntervantionsSummary(data: IFetchScheduledInterventionsProgressRequest, patientId: string): Promise<Array<IFetchScheduledInterventionsProgresssResponse>> {
        return ApiManager.getEHRApis().getIntervantionsSummary(data, patientId);
    }

    static getDailyViewData(data: IFetchScheduledInterventionsRequest): Promise<Array<IFetchScheduledInterventionsResponse>> {
        return ApiManager.getEHRApis().getScheduledInterventions(data);
    }

    static getScheduledInterventionsHistory(patientId: string): Promise<Array<IFetchScheduledInterventionsResponse[]>> {
        return ApiManager.getEHRApis().getScheduledInterventionsHistory(patientId);
    }

    static getSugarJournalData(params:ISugarJournalRequest):Promise<ISugarJournalResponse[]>{
        return ApiManager.getMetricServiceApis().fetchChronicCareGlucose(params);
    }
}